import { NavigateFunction } from 'react-router-dom';
import { Escort } from '../types';
import { createEscortUrl } from './urlUtils';

/**
 * Handles navigation to an escort's profile page
 * @param id - The escort's ID
 * @param escorts - Array of all escorts to find the specific one
 * @param navigate - React Router's navigate function
 * @param requirePhone - Whether to require phone number for navigation (default: false)
 */
export const handleViewProfile = (
  id: string,
  escorts: Escort[],
  navigate: NavigateFunction,
  requirePhone: boolean = false
) => {
  const escort = escorts.find(e => e.id === id);
  if (escort && (!requirePhone || escort.phone)) {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate(createEscortUrl(escort));
  }
};
